<script type="ts">
    import { useNavigate } from 'svelte-navigator';
    import sessionStore from '../../store/session';
    import authStore from '../../store/auth';
    import ButtonRounded from '../../common/ButtonRounded.svelte';
    import type { Profile } from '../../types/session';
    import { onMount } from 'svelte';
    import { getBusinesses as GetBusinesses } from '../../domain/session/profile.action'
    import Header from '../../components/Header.svelte';
    import Footer from '../../components/Footer.svelte';
    import toast from '../../services/toast';
    import Icon from '../../components/Icon.svelte';
    import { getBusinessWidgetConfig as GetBusinessWidgetConfig } from '../../domain/session/receivers.actions';
    import { configureCss, ICONS } from '../../services/utils';
    import widgetStore from '../../store/widget'

    const navigate = useNavigate();
    let loading = false
    let errors: Record<string, string> = {}
    let businesses: Array<Profile | any> = $sessionStore.profiles || []

    const handleBusinessSelection = async (profile) => {
        errors = {}
        sessionStore.setProfile(profile);
        sessionStore.setReceivers([])

        if ( profile.business.id ) {
            try {
                const config = await GetBusinessWidgetConfig(profile.business.id);
                widgetStore.set(config)
                configureCss(config)
                window.parent.postMessage(config, "*")
            } catch (_) {}
        }

        return Promise.resolve(null)
    }

    const handleContinueClick = () => {
        if (Object.values($sessionStore.profile).length === 0) {
            errors.review = "please select a business before you proceed."
            toast.error({message: errors.review})
            return;
        }
        navigate("/choose-number")
    }

    onMount(async () => {
        // if (!$sessionStore.profiles || ($sessionStore.profiles && $sessionStore.profiles.length === 0)) {
            await loadProfiles()
        // }
    });

    const loadProfiles = async () => {
        loading = true
        try {
            const { user, profiles } = await GetBusinesses()
            businesses = profiles
            authStore.setUser(user);
            sessionStore.setProfiles(profiles)
        } catch (error) {
            const { message = "Ops! seems error occured!"} = error
            errors.review = message
            toast.error({message})
        } finally {
            loading = false
        }
    }
    
</script>

<Header />
<div class="flex h-full justify-center items-center">
    <div class="w-full">
        <div class="display-flex">
            <div class="flex flex-col w-full">
                
                <div class="relative mx-8 mt-16 mb-8 text-gray-400 text-left">
                    <strong class="text-black text-md secondary-text-color">
                        Select Business
                    </strong>
                    <br/>
                    <!-- <span class="text-xs">
                        Enter the 6-digit code sent to 0802 343 8492 to validate your access.
                    </span> -->

                    <div class="mt-4 w-full">
                        <div class="">
                            {#if businesses.length > 0}
                            <div class="flex flex-col h-1/2 overflow-y-scroll" style="height: 35vh;">
                                <ul>
                                    {#each businesses as profile}
                                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                                        <li 
                                            class="flex justify-between my-4 pr-4" 
                                            on:click={() => handleBusinessSelection(profile)}
                                        >
                                            <div class="flex">
                                                <img src={ICONS.logo} alt="logo" width="25px" /> &nbsp;
                                                { profile.business.name }
                                            </div>
                                            <div>
                                                <input 
                                                    checked={$sessionStore.profile?.business?.id === profile.business.id}
                                                    type="radio" 
                                                    name="business_selection" 
                                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                                />
                                            </div>
                                        </li>
                                    {/each}
                                </ul>
                            </div>
                            {:else}
                                <div class="mb-4 text-xs text-center mt-4">
                                    No business info. 
                                    <p>
                                        Click here to 
                                        <button 
                                            on:click={loadProfiles} 
                                            class="border px-2"
                                            disabled={loading}
                                        >&#8634; refresh</button>
                                    </p>
                                </div>
                            {/if}
                            {#if loading}
                                <div class="flex justify-center items-center h-4/6" style="height: 16rem;">
                                    <Icon icon="loader" />
                                    <i class="animate-pulse">loading record...</i>
                                </div>
                            {/if}
                            <ButtonRounded
                                disabled={Object.values($sessionStore.profile || {}).length === 0}
                                on:click={handleContinueClick}
                                title=""
                                loading={loading}
                                className="call-btn-bg-color h-10 mt-4 w-full flex-inline text-white px-8 text-sm"
                            >
                            Continue
                            </ButtonRounded>
                        </div>
                        {#if errors.review}
                            <small class="text-xs text-red-500">{ errors.review }</small>
                        {/if}
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
<Footer />
<style>
    /* .primary-text-color {
        color: var(--primary-text-color)
    } */
    .secondary-text-color {
        color: var(--secondary-text-color)
    }
</style>
